import { createContext, useEffect, useRef, useState, useContext } from 'react'

// ** Next Import
import { useRouter } from 'next/router'

// ** Axios
import axios from 'axios'

// ** Config
import authConfig from 'src/configs/auth'
import {
  getClientListUrl,
  getDefaultEmailUrl,
  listUsersUrl,
  tagListUrl,
  getLoginClientListUrl,
  // clientLogin,
  getClientChannels,
  GetSettings,
  GetClientIDsByUserID,
  filterUrl,
  notificationMessageUrl,
  notificationBaseUrl,
  markAllNotificationsReadUrl,
  getAutoCompleteTextUrl,
  acceptTermsUrl
} from 'src/configs/api'

import { useAPI } from 'src/utils/api'
import { CampaignContext } from './CampaignContext'
import { authStorage } from 'src/utils/authStorage'
import { useToast } from 'src/@core/components/custom-Toast/customToast'

// ** Defaults
const defaultProvider = {
  user: null,
  loading: true,
  setUser: () => null,
  userListRow: [],
  setUserListRow: () => null,
  setLoading: () => Boolean,
  isInitialized: false,
  setIsInitialized: () => Boolean,
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  listUser: () => Promise.resolve(),
  forgotpwdEmail: '',
  setForgotpwdEmail: () => null,
  tagListData: [],
  setTagListData: () => null,
  senderEmail: '',
  setSenderEmail: () => null,
  replyEmail: '',
  setReplyEmail: () => null,
  subscriptionData: [],
  setSubscriptionData: () => null,
  showLogin: false,
  setShowLogin: () => Boolean,
  showClient: true,
  setShowClient: () => Boolean,
  showClientData: false,
  setShowClientData: () => Boolean,
  clientData: {
    email: '',
    clients: []
  },
  //  clientData: [],
  setClientData: () => null,
  selectedClientId: '',
  setSelectedClientId: () => null,
  tempAuthToken: '',
  setTempAuthToken: () => null,
  loginEmail: '',
  setLoginEmail: () => null,
  loginPassword: '',
  setLoginPassword: () => null,
  logoUrlFromSettings: '',
  setLogoUrlFromSettings: () => null,
  favUrlFromSettings: '',
  setfavUrlFromSettings: () => null,
  socketData: [],
  setSocketData: () => null,
  isUserLoggedIn: false,
  setIsUserLoggedIn: () => null,
  isConnected: false,
  setIsConnected: () => Boolean,
  notificationMessage: '',
  setNotificationMessage: () => null,
  openPopUp: false,
  setOpenPopUp: () => Boolean,
  expirationTime: 0,
  setExpirationTime: () => null,
  loggedInClientId: '',
  setLoggedInClientId: () => null,
  activeClientChannels: [],
  setActiveClientChannels: () => null,
  usersCount: 0,
  setUsersCount: () => null,
  verifiedSmtpConfigList: [],
  setVerifiedSmtpConfigList: () => null,
  verifiedWhatsappSmtpConfigList: [],
  setVerifiedWhatsappSmtpConfigList: () => null,
  verifiedSmsSmtpConfigList: [],
  setVerifiedSmsSmtpConfigList: () => null,
  verifiedRcsSmtpConfigList: [],
  setVerifiedRcsSmtpConfigList: () => null,
  rememberMe: true,
  setRememberMe: () => Boolean,
  aiEnabled: authStorage.getAIConfiguration('aiConfiguration'),
  setAiEnabled: () => Boolean,
  userFilterList: [],
  setUserFilterList: () => null,
  userOtherFilterList: [],
  setUserOtherFilterList: () => null,
  hasTagFilter: false,
  setHasTagFilter: () => null,
  loginMessagePending: false,
  setLoginMessagePending: () => null,
  loginError: '',
  setLoginError: () => null,
  showTermsModal: false,
  setShowTermsModal: () => null,
  isAcceptingTerms: false,
  acceptTerms: () => Promise.resolve(),
  fetchNotificationContent: () => Promise.resolve(),
  markAsRead: () => Promise.resolve(),
  markAllAsRead: () => Promise.resolve(),
  getAutoCompleteText: () => Promise.resolve()
}

const AuthContext = createContext(defaultProvider)

const AuthProvider = ({ children }) => {
  // ** States
  const [user, setUser] = useState(defaultProvider.user)

  const [loading, setLoading] = useState(defaultProvider.loading)
  const [isInitialized, setIsInitialized] = useState(defaultProvider.isInitialized)

  const [authToken, setAuthToken] = useState('')

  const [activeClientChannels, setActiveClientChannels] = useState(defaultProvider.activeClientChannels)

  const [tempAuthToken, setTempAuthToken] = useState(defaultProvider.tempAuthToken)

  const [userListRow, setUserListRow] = useState(defaultProvider.userListRow)

  const [forgotpwdEmail, setForgotpwdEmail] = useState(defaultProvider.forgotpwdEmail)

  const [tagListData, setTagListData] = useState(defaultProvider.tagListData)

  const [senderEmail, setSenderEmail] = useState(defaultProvider.senderEmail)

  const [replyEmail, setReplyEmail] = useState(defaultProvider.replyEmail)

  const [subscriptionData, setSubscriptionData] = useState(defaultProvider.subscriptionData)

  const [showLogin, setShowLogin] = useState(defaultProvider.showLogin)
  const [aiEnabled, setAiEnabled] = useState(defaultProvider.aiEnabled)

  const [showClient, setShowClient] = useState(defaultProvider.showClient)

  const [showClientData, setShowClientData] = useState(defaultProvider.showClientData)

  const [clientData, setClientData] = useState(defaultProvider.clientData)

  const [selectedClientId, setSelectedClientId] = useState(defaultProvider.selectedClientId)

  const [loginEmail, setLoginEmail] = useState(defaultProvider.loginEmail)

  const [loginPassword, setLoginPassword] = useState(defaultProvider.loginPassword)

  const [logoUrlFromSettings, setLogoUrlFromSettings] = useState(defaultProvider.logoUrlFromSettings)

  const [favUrlFromSettings, setfavUrlFromSettings] = useState(defaultProvider.favUrlFromSettings)

  const [socketData, setSocketData] = useState(defaultProvider.socketData)

  const [isConnected, setIsConnected] = useState(defaultProvider.isConnected)

  const [notificationMessage, setNotificationMessage] = useState(defaultProvider.notificationMessage)

  const [openPopUp, setOpenPopUp] = useState(defaultProvider.openPopUp)

  const [isUserLoggedIn, setIsUserLoggedIn] = useState(defaultProvider.isUserLoggedIn)

  const [expirationTime, setExpirationTime] = useState(defaultProvider.expirationTime)

  const [loggedInClientId, setLoggedInClientId] = useState(defaultProvider.loggedInClientId)

  const [usersCount, setUsersCount] = useState(defaultProvider.usersCount)

  const [verifiedSmtpConfigList, setVerifiedSmtpConfigList] = useState(defaultProvider.verifiedSmtpConfigList)

  const [verifiedWhatsappSmtpConfigList, setVerifiedWhatsappSmtpConfigList] = useState(
    defaultProvider.verifiedWhatsappSmtpConfigList
  )
  const [verifiedSmsSmtpConfigList, setVerifiedSmsSmtpConfigList] = useState(defaultProvider.verifiedSmsSmtpConfigList)
  const [verifiedRcsSmtpConfigList, setVerifiedRcsSmtpConfigList] = useState(defaultProvider.verifiedRcsSmtpConfigList)

  const [rememberMe, setRememberMe] = useState(defaultProvider.rememberMe)

  const [isProcessing, setIsProcessing] = useState(defaultProvider.isProcessing)
  const [isNextStepLoading, setIsNextStepLoading] = useState(defaultProvider.isNextStepLoading)
  const [userFilterList, setUserFilterList] = useState(defaultProvider.userFilterList)
  const [userOtherFilterList, setUserOtherFilterList] = useState(defaultProvider.userOtherFilterList)
  const [hasTagFilter, setHasTagFilter] = useState(defaultProvider.hasTagFilter)
  const [loginMessagePending, setLoginMessagePending] = useState(defaultProvider.loginMessagePending)
  // Inline login error (replaces the toast) — string | ''
  const [loginError, setLoginError] = useState('')
  const [showTermsModal, setShowTermsModal] = useState(defaultProvider.showTermsModal)
  const [isAcceptingTerms, setIsAcceptingTerms] = useState(defaultProvider.isAcceptingTerms)

  const router = useRouter()
  const { setReplyToEmail } = useContext(CampaignContext)
  const api = useAPI()
  const storedToken = authStorage.getStoredToken(authConfig.storageTokenKeyName)
  const { showSuccess, showError } = useToast()

  const hasLoggedOut = useRef(false)
  useEffect(() => {
    const initAuth = async () => {
      setLoading(false)

      if (storedToken) {
        setLoading(true)
        await api
          .get(authConfig.meEndpoint)
          .then(async response => {
            setLoading(false)
            setUser(response?.data?.data)
            setIsUserLoggedIn(true)
            setShowTermsModal(response?.data?.data?.termsAccepted === false)
            getSettingsData()
          })
          .catch(() => {
            localStorage.removeItem('userData')
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('accessToken')
            localStorage.removeItem('clientData')
            localStorage.removeItem('selectedClientId')
            setLoading(false)
            handleLogout()
          })
      } else {
        setLoading(false)
      }
    }

    initAuth()
  }, [])
  useEffect(() => {
    const handleStorageChange = e => {
      if (e.key === 'logout') {
        handleLogout(true)
        showError('You have been logged out from another tab')
      }
    }

    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [])

  useEffect(() => {
    if (expirationTime) {
      const currentTimeInSeconds = Math.floor(Date.now() / 1000)
      const timeLeft = expirationTime - currentTimeInSeconds

      if (timeLeft > 0) {
        const timeoutId = setTimeout(handleLogout, timeLeft * 1000)
        return () => clearTimeout(timeoutId)
      } else {
        handleLogout()

        showError('Session expired, Please log in again')
      }
    }
  }, [expirationTime])
  useEffect(() => {
    window.localStorage.removeItem('showLogoutToast')
  }, [])

  const listUser = payload => {
    api
      .post(`${listUsersUrl}/search`, payload)
      .then(async response => {
        setUserListRow(response?.data?.data?.users || [])
        setUsersCount(response?.data?.data?.total || 0)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        if (error.response && error.response?.status === 401) {
          showError('Session expired. Please log in again.')
          handleLogout()
        }
      })
  }

  const getUserFilterList = async () => {
    try {
      const response = await api.get(`${filterUrl}/users`)

      const filters = response?.data?.data?.filters || []
      const otherFilters = response?.data?.data?.otherFilters || []

      const tagsFilter = filters.find(f => f.key === 'tags')
      setHasTagFilter(!!tagsFilter)
      setUserFilterList(tagsFilter ? tagsFilter.options.map(o => o.value) : [])
      setUserOtherFilterList(otherFilters)

      const initialSelectedFilters = {}
      otherFilters.forEach(f => {
        initialSelectedFilters[f.key] = []
      })

      return initialSelectedFilters
    } catch {
      setUserFilterList([])
      setUserOtherFilterList([])
      return {}
    }
  }

  const getUser = () => {
    api.get(authConfig.meEndpoint).then(async response => {
      const responseUserData = response?.data?.data

      setUser(responseUserData)
      authStorage.setStoredUser('userData', responseUserData, rememberMe)
      setShowTermsModal(responseUserData?.termsAccepted === false)
      getClientAIConfiguration()
    })
  }

  const getTag = async () => {
    const response = await api.get(tagListUrl)

    setTagListData(response?.data)
    window.localStorage.setItem('tagListData', JSON.stringify(response?.data))
  }

  const getLoginClientList = async handleopenClientList => {
    setLoginError('')
    try {
      const inputData = {
        email: loginEmail?.trim(),
        password: loginPassword
      }
      const response = await axios.post(getLoginClientListUrl, inputData)
      const tempToken = response?.headers?.authorization
      if (tempToken) {
        setTempAuthToken(tempToken)
        authStorage.setUserToken(tempToken, rememberMe)
        await getClientList(tempToken, handleopenClientList)
      }
    } catch (error) {
      const capitalizeFirst = str => (str ? str.charAt(0).toUpperCase() + str.slice(1) : str)

      const status = error?.response?.status
      const errorMessage = error?.response?.data?.message || error?.message || 'An unexpected error occurred'

      let message = errorMessage

      if (status === 401) {
        message = errorMessage || 'Your session has expired. Please log in again.'
        setLoginError(capitalizeFirst(message))
        if (errorMessage !== 'Wrong password, Please try again') {
          handleLogout()
        }
      } else if (status === 403) {
        message = errorMessage || 'You do not have permission to perform this action.'
        setLoginError(capitalizeFirst(message))
      } else if (status === 404) {
        message = errorMessage || 'The requested resource was not found.'
        setLoginError(capitalizeFirst(message))
      } else if (status === 400) {
        message = errorMessage || 'Bad request. Please check your input and try again.'
        setLoginError(capitalizeFirst(message))
      } else if (status >= 500) {
        message = errorMessage || 'Server error. Please try again later.'
        setLoginError(capitalizeFirst(message))
      } else {
        setLoginError(capitalizeFirst(message))
      }
    }
  }

  const fetchNotificationContent = async notificationId => {
    setNotificationMessage('')
    const token = authStorage.getStoredToken(authConfig.storageTokenKeyName)
    const response = await axios.get(`${notificationMessageUrl}/${notificationId}`, {
      headers: { Authorization: token }
    })
    const content = response?.data
    if (content.data?.contentMessage) {setNotificationMessage(content.data.contentMessage)}
    return content
  }

  const markAsRead = async notificationId => {
    try {
      const token = authStorage.getStoredToken(authConfig.storageTokenKeyName)
      await axios.put(`${notificationBaseUrl}/${notificationId}/read`, null, {
        headers: { Authorization: token }
      })
      setSocketData(
        prev => prev?.map(n => (n.notificationId === notificationId ? { ...n, messageReadStatus: 'read' } : n)) ?? []
      )
    } catch {}
  }

  const markAllAsRead = async () => {
    try {
      const token = authStorage.getStoredToken(authConfig.storageTokenKeyName)
      await axios.put(markAllNotificationsReadUrl, null, {
        headers: { Authorization: token }
      })
      setSocketData(prev => prev?.map(n => ({ ...n, messageReadStatus: 'read' })) ?? [])
    } catch {}
  }

  const acceptTerms = async () => {
    setIsAcceptingTerms(true)
    try {
      await api.post(acceptTermsUrl)
      setShowTermsModal(false)
    } catch {
      showError('Failed to record acceptance. Please try again.')
    } finally {
      setIsAcceptingTerms(false)
    }
  }

  const handleLoginClient = async (params, errorCallback, clientTempAuthToken) => {
    if (!clientTempAuthToken) {
      showError('No stored token available for authentication')
      return
    }

    const inputData = {
      clientId: params.clientId,
      email: params.email,
      is_favourite: params.is_favourite || false
    }

    try {
      const response = await axios.post(authConfig.clientLoginEndpoint, inputData, {
        headers: {
          Authorization: clientTempAuthToken
        }
      })
      const expiry = response?.data.data.expiry
      setExpirationTime(expiry)
      const newToken = response?.headers.authorization

      if (newToken) {
        // Store the new token
        setAuthToken(newToken)
        rememberMe === true
          ? window.localStorage.setItem(authConfig.storageTokenKeyName, newToken)
          : window.sessionStorage.setItem(authConfig.storageTokenKeyName, newToken)
      }
      const clientListResponse = await axios.get(getClientListUrl, {
        headers: { Authorization: clientTempAuthToken }
      })

      const updatedClientData = clientListResponse?.data.data
      setClientData(updatedClientData)
      authStorage.setStoredClientData('clientData', JSON.stringify(updatedClientData), rememberMe)

      // Continue login flow
      setExpirationTime(expiry)
      getUser()

      const returnUrl = router.query.returnUrl
      const redirectURL = returnUrl && returnUrl !== '/' ? returnUrl : '/'

      router.replace(redirectURL)
      authStorage.isUserLoggedInStatus()
      hasLoggedOut.current = false
      setLoginMessagePending(true)
      setIsUserLoggedIn(true)
    } catch (err) {
      if (errorCallback) {
        errorCallback(err)
      }
      // showError('Cannot login', err)
    }
  }

  const handleLogin = (params, errorCallback) => {
    api
      .post(authConfig.loginEndpoint, params)
      .then(async response => {
        const token = response?.headers.authorization
        setAuthToken(token)
        authStorage.setStoredToken(authConfig.storageTokenKeyName, token, rememberMe)

        const returnUrl = router.query.returnUrl

        getUser()
        const redirectURL = returnUrl && returnUrl !== '/' ? returnUrl : '/'

        router.replace(redirectURL)
      })
      .catch(error => {
        localStorage.removeItem(authConfig.storageTokenKeyName)
        localStorage.removeItem('userData')
        if (errorCallback) {
          errorCallback(error)
        }
        // showError('cannot login', err)
      })
  }

  useEffect(() => {
    const storedClientData = authStorage.getStoredClientData('clientData')
    if (storedToken) {
      getClientAIConfiguration()
    }
    if (storedClientData) {
      setClientData(JSON.parse(storedClientData))
    }
  }, [])

  const handleLogout = (isBroadcast = false) => {
    if (hasLoggedOut.current) {return}
    hasLoggedOut.current = true

    window.localStorage.removeItem('clientData')
    window.localStorage.removeItem('selectedClientId')
    authStorage.clearAuth()

    if (!isBroadcast) {
      // Broadcast to other tabs
      window.localStorage.setItem('logout', Date.now().toString())
      window.localStorage.setItem('showLogoutToast', 'true')
    }

    // Single navigation — hard reload clears JS heap memory
    window.location.href = '/login'
  }

  const getConfigurationList = async (type, channel) => {
    try {
      const selectedChannel = activeClientChannels.find(c => c.channelName.toLowerCase() === channel.toLowerCase())

      if (!selectedChannel) {
        return
      }

      // Extract the channel ID
      const channelId = selectedChannel.channelId

      // Then make your API call using it
      const response = await api.get(`${getDefaultEmailUrl}/channel/${channelId}`, {
        params: { type }
      })

      const configurationList = response?.data?.data
      if (selectedChannel === 'email' || channel === 'email') {
        setVerifiedSmtpConfigList(configurationList)
      } else if (selectedChannel === 'whatsapp' || channel === 'whatsapp') {
        setVerifiedWhatsappSmtpConfigList(configurationList)
      } else if (selectedChannel === 'sms' || channel === 'sms') {
        setVerifiedSmsSmtpConfigList(configurationList)
      } else if (selectedChannel === 'rcs' || channel === 'rcs') {
        setVerifiedRcsSmtpConfigList(configurationList)
      }
      return response?.data
    } catch {}
  }

  const getVerifiedSmtpConfigList = async (type, channel) => {
    try {
      const response = await api.get(`${getDefaultEmailUrl}/verified-configs`, {
        params: {
          campaignType: type,
          channelName: channel
        }
      })
      const smtpConfigs = response?.data?.data || []
      setVerifiedSmtpConfigList(smtpConfigs)
    } catch (error) {
      const capitalizeFirst = str => (str ? str.charAt(0).toUpperCase() + str.slice(1) : str)
      let message = 'Something went wrong. Please try again.'

      if (error) {
        const errorMessage = error?.response?.data?.message
        const status = error?.response?.status

        if (status === 401) {
          message = errorMessage || 'Your session has expired. Please log in again.'
          showError(capitalizeFirst(message))
          handleLogout()
        } else if (status === 403) {
          message = errorMessage || 'You do not have permission to perform this action.'
          showError(capitalizeFirst(message))
        } else if (status === 404) {
          message = errorMessage || 'The requested resource was not found.'
          showError(capitalizeFirst(message))
        } else if (status === 400) {
          message = errorMessage || 'Bad request. Please check your input and try again.'
          showError(capitalizeFirst(message))
        } else if (status >= 500) {
          message = errorMessage || 'Server error. Please try again later.'
          showError(capitalizeFirst(message))
        }
      } else if (error.request) {
        message = 'Network error. Please check your connection.'
        showError(capitalizeFirst(message))
      }

      showError(capitalizeFirst(message))
    }
  }

  const getClientList = async (tempToken, handleopenClientList) => {
    if (!tempToken) {
      showError('No stored token available for authentication')
      return // Prevent further execution if no token is available
    }

    try {
      const response = await api.get(getClientListUrl, {
        headers: {
          Authorization: tempToken
        }
      })
      const responseData = response?.data?.data
      const userEmail = responseData.email
      setClientData(response?.data?.data)

      authStorage.setStoredClientData('clientData', JSON.stringify(responseData), rememberMe)

      const clients = response?.data?.data?.clients || []
      if (clients.length > 0) {
        if (clients.length === 1) {
          const singleClientId = clients[0].clientId
          setSelectedClientId(singleClientId)
          await handleLoginClient(
            {
              clientId: singleClientId,
              email: userEmail,
              is_favourite: true
            },
            null,
            tempToken
          )
        } else {
          const favouriteClient = clients.find(client => client.is_favourite === true)

          if (favouriteClient) {
            setSelectedClientId(favouriteClient.clientId)
            await handleLoginClient(
              {
                clientId: favouriteClient.clientId,
                email: userEmail,
                is_favourite: true
              },
              null,
              tempToken
            )
          } else {
            handleopenClientList()
          }
        }
      }
    } catch (error) {
      const capitalizeFirst = str => (str ? str.charAt(0).toUpperCase() + str.slice(1) : str)
      let message = 'Something went wrong. Please try again.'

      if (error) {
        const errorMessage = error?.response?.data?.message
        const status = error?.response?.status
        if (status === 401) {
          message = errorMessage || 'Your session has expired. Please log in again.'
          showError(capitalizeFirst(message))
          handleLogout()
        } else if (status === 403) {
          message = errorMessage || 'You do not have permission to perform this action.'
          showError(capitalizeFirst(message))
        } else if (status === 404) {
          message = errorMessage || 'The requested resource was not found.'
          showError(capitalizeFirst(message))
        } else if (status === 400) {
          message = errorMessage || 'Bad request. Please check your input and try again.'
          showError(capitalizeFirst(message))
        } else if (status >= 500) {
          message = errorMessage || 'Server error. Please try again later.'
          showError(capitalizeFirst(message))
        }
      } else if (error.request) {
        message = 'Network error. Please check your connection.'
        showError(capitalizeFirst(message))
      }

      // showError(errorMessage)
    }
  }

  const bulkDeleteUser = async selectedRows => {
    try {
      await api.delete(`${listUsersUrl}/bulk`, {
        data: {
          userIds: selectedRows
        }
      })
    } catch {
      showError('Failed to delete reports')
    }
  }
  const findAnotherClient = () => {
    setShowClient(true)
    setShowClientData(false)
    setShowLogin(false)
  }

  const goToLogin = () => {
    setShowLogin(true)
    setShowClient(false)
    setShowClientData(false)
  }

  const updateFavicon = url => {
    const favicon = document.getElementById('favicon')

    if (favicon) {
      favicon.setAttribute('href', url)
    }
  }

  const getSettingsData = async () => {
    // Removing favUrl and logoUrl from localStorage
    localStorage.removeItem('favUrl')
    localStorage.removeItem('logoUrl')

    try {
      const response = await api.get(GetSettings)

      const data = response?.data?.data

      // Check if ADMIN_SETTINGS_GENERAL exists and has data
      if (data && data.ADMIN_SETTINGS_GENERAL && data.ADMIN_SETTINGS_GENERAL.length > 0) {
        const appData = data.ADMIN_SETTINGS_GENERAL[0]

        const logoUrl = appData['app.logo_url']

        const faviconUrl = appData['app.favicon_url']

        const reply_Email = appData['reply.to_email']

        if (reply_Email) {
          setReplyEmail(reply_Email)
          setReplyToEmail(reply_Email)
        } else {
          //console.warn('reply_Email is undefined or empty')
        }

        // If the data is valid, store in state or localStorage
        if (logoUrl && faviconUrl) {
          setfavUrlFromSettings(faviconUrl)
          setLogoUrlFromSettings(logoUrl)
          localStorage.setItem('favUrl', faviconUrl)
          localStorage.setItem('logoUrl', logoUrl)
          updateFavicon(faviconUrl)
        }
      }
    } catch {
      // showError('An error occurred while fetching the settings data.')
    }
  }

  const fetchClientChannels = async () => {
    try {
      const response = await api.get(getClientChannels)
      const channelsList = response?.data?.data
      const activeChannels = filterEnabledChannels(channelsList)
      setActiveClientChannels(activeChannels)
    } catch {}
  }

  const filterEnabledChannels = channels => {
    return channels?.filter(channel => channel.channelStatus === 'enabled')
  }

  const updateUserClientFavouriteStatus = async (clientId, isFavourite) => {
    try {
      const inputData = {
        clientId: clientId,
        is_favourite: isFavourite
      }
      const response = await api.put(authConfig.updateUserClientFavouriteStatusEndpoint, inputData)
      if (response?.status === 200) {
        showSuccess('Client favourite status updated successfully')
      }
    } catch {
      // console.error('Error updating favourite status:', error)
    }
  }
  const getClientAIConfiguration = async () => {
    try {
      const inputData = {
        config_key: 'ai'
      }
      const response = await api.post(`${GetClientIDsByUserID}/status`, inputData)
      const aiConfigData = response?.data?.data?.is_enabled
      authStorage.setAIConfiguration('aiConfiguration', aiConfigData, rememberMe)
      setAiEnabled(aiConfigData)
    } catch {}
  }
  const updateClientAIConfiguration = async aiEnabledValue => {
    try {
      const inputData = {
        config_key: 'ai',
        is_enabled: aiEnabledValue
      }

      const response = await api.put(`${GetClientIDsByUserID}/status`, inputData)
      if (response?.status === 200) {
        authStorage.setAIConfiguration('aiConfiguration', aiEnabledValue, rememberMe)
        setAiEnabled(aiEnabledValue)
        showSuccess(response?.data?.data || 'AI configuration set')
      }
    } catch {}
  }

  const getAutoCompleteText = async (input, mode) => {
    try {
      const response = await api.post(getAutoCompleteTextUrl, { text: input, mode })
      return response?.data?.data?.text
    } catch {
      return
    }
  }

  const values = {
    activeClientChannels,
    setActiveClientChannels,
    user,
    loading,
    isInitialized,
    setIsInitialized,
    setUser,
    setLoading,
    forgotpwdEmail,
    setForgotpwdEmail,
    userListRow,
    setUserListRow,
    login: handleLogin,
    authToken,
    setAuthToken,
    logout: handleLogout,
    listUser: listUser,
    tagListData,
    setTagListData,
    getTag: getTag,
    getVerifiedSmtpConfigList: getVerifiedSmtpConfigList,
    subscriptionData,
    setSubscriptionData,
    getClientList: getClientList,
    showLogin,
    setShowLogin,
    aiEnabled,
    setAiEnabled,
    goToLogin: goToLogin,
    findAnotherClient: findAnotherClient,
    showClient,
    setShowClient,
    showClientData,
    setShowClientData,
    getLoginClientList: getLoginClientList,
    clientData,
    setClientData,
    selectedClientId,
    setSelectedClientId,
    handleLoginClient: handleLoginClient,
    fetchClientChannels: fetchClientChannels,
    loginEmail,
    loginPassword,
    setLoginEmail,
    setLoginPassword,
    logoUrlFromSettings,
    setLogoUrlFromSettings,
    favUrlFromSettings,
    setfavUrlFromSettings,
    getSettingsData,
    socketData,
    setSocketData,
    isUserLoggedIn,
    setIsUserLoggedIn,
    isConnected,
    setIsConnected,
    notificationMessage,
    setNotificationMessage,
    openPopUp,
    setOpenPopUp,
    tempAuthToken,
    setTempAuthToken,
    loggedInClientId,
    setLoggedInClientId,
    usersCount,
    setUsersCount,
    verifiedSmtpConfigList,
    setVerifiedSmtpConfigList,
    verifiedRcsSmtpConfigList,
    verifiedSmsSmtpConfigList,
    verifiedWhatsappSmtpConfigList,
    setVerifiedRcsSmtpConfigList,
    setVerifiedSmsSmtpConfigList,
    setVerifiedWhatsappSmtpConfigList,
    senderEmail,
    setSenderEmail,
    replyEmail,
    setReplyEmail,
    rememberMe,
    setRememberMe,
    isProcessing,
    setIsProcessing,
    isNextStepLoading,
    setIsNextStepLoading,
    getConfigurationList,
    updateClientAIConfiguration: updateClientAIConfiguration,
    updateUserClientFavouriteStatus: updateUserClientFavouriteStatus,
    getUserFilterList: getUserFilterList,
    userFilterList,
    setUserFilterList,
    userOtherFilterList,
    setUserOtherFilterList,
    hasTagFilter,
    setHasTagFilter,
    loginMessagePending,
    setLoginMessagePending,
    loginError,
    setLoginError,
    showTermsModal,
    setShowTermsModal,
    isAcceptingTerms,
    acceptTerms,
    fetchNotificationContent,
    markAsRead,
    markAllAsRead,
    getAutoCompleteText,
    bulkDeleteUser
  }

  return <AuthContext.Provider value={values}>{children}</AuthContext.Provider>
}

export { AuthContext, AuthProvider }
